import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

const DarkModeToggle = ({ className = '', size = 'medium' }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  const getIconSize = () => {
    switch (size) {
      case 'small': return 16;
      case 'large': return 24;
      default: return 20;
    }
  };

  return (
    <Tooltip title={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
      <IconButton
        className={className}
        onClick={toggleTheme}
        data-theme={theme}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        size={size}
        sx={{
          color: 'text.primary',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        {isDark ? (
          <LightMode sx={{ fontSize: getIconSize() }} />
        ) : (
          <DarkMode sx={{ fontSize: getIconSize() }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeToggle;
